import { memo } from "react";
import { Modal, Button } from "antd";
import IntlMessages from "../Message/IntlMessages";
import DisclaimerMessage from "../Message/DisclaimerMessage";

const AmendHNW = ({ code, close, state, actions, ...modalProps }) => {
  function _onAccept() {
    close();
    actions?.onAccept && actions.onAccept(code);
  }

  function _onCancel() {
    close();
    actions?.onCancel && actions.onCancel();
  }

  return (
    <Modal {...modalProps}>
      {modalProps.visible && (
        <div className="mnc-modal-style-1">
          <div className="modal-mnc-head">
            <h5 className="m-0">
              <IntlMessages id="modal.disclaimer.header.hnw" />
            </h5>
            <Button className="btn button-ktb-close" onClick={_onCancel}>
              <i className="feather-icon icon-x"></i>{" "}
            </Button>
          </div>
          <div className="modal-mnc-body">
            <DisclaimerMessage code={code} dangerous />
          </div>
          <div className="modal-mnc-footer">
            <div className="row justify-content-center">
              <div className="col-6 pe-1 pe-md-2">
                <div className="d-grid">
                  <Button data-cancel-btn className="btn button-ktb-line" onClick={_onCancel}>
                    <IntlMessages id="global.cancel" />
                  </Button>
                </div>
              </div>
              <div className="col-6 ps-1 ps-md-2">
                <div className="d-grid">
                  <Button data-accept-btn className="btn button-ktb-main" onClick={_onAccept}>
                    <IntlMessages id="global.confirm" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default memo(AmendHNW);
